<template lang="pug">
  .cPagination
    .cPaginationContent(ref="wrapEle")
      div(ref="overflowEle" slot="content" @touchmove="loadMore")
        slot(name="dataList")
      //- 暂无数据
      .no_data(v-if="data.length <= 0 && noMoreImg && !$from")
        img(:src="noMoreImg")
        p.no_more_text {{noMoreText}}
        p.no_more_btn(v-if="noMoreBtn" @click="$router.push(noMoreUrl)") {{noMoreBtn}}
      .no_data(v-if="data.length <= 0 && !noMoreImg && !moreNotShow") {{type == '义诊' ? '该时间段无出诊医师在线，请稍后再试' : '暂无数据~'}}
      //- 加载更多
      .more(v-if="hasMore" ref="more")
        p.nodata 上拉加载更多
        //cPartLoading(:loading="false")
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'
export default {
  props: ['data', 'noMoreImg', 'noMoreUrl', 'noMoreText', 'noMoreBtn', 'moreNotShow', 'type'],
  computed: {
    ...mapState({
      hasMore: (state) => state.hasMore
    })
  },
  methods: {
    // 加载更多
    // loadMore: window._.debounce(function () {
    loadMore: debounce(function () {
      // 判断是否还有更多分页
      // 判断加载更多按钮是否进入可视区域
      let isMoreSee = window.utils.enterVisualScope(this.$refs.overflowEle, this.$refs.wrapEle, this.$refs.wrapEle)
      if (isMoreSee) {
        this.$emit('morePage')
      }
    }, 1000)
  }
}
</script>

<style lang="less" scoped>
@import '../styles/base';
.cPagination {
  width: 100%;
  height: 100%;
  .cPaginationContent {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow-x: hidden;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  }
}

// 加载更多
.more {
  position: relative;
  .nodata {
    width: 100%;
    font-size: 14px;
    color: #8c8c8c;
    text-align: center;
    margin-bottom: 10px;
  }
}

.no_data {
  text-align: center;
  img {
    display: block;
    margin: 2rem auto 0;
    width: 40%;
  }
  p {
    text-align: center;
  }
  .no_more_text {
    margin-top: 2rem;
    color: @sub_color;
  }
  .no_more_btn {
    width: 90%;
    margin: 2em auto;
    font-size: 1.6em;
    color: #fff;
    background-color: @main_color;
    text-align: center;
    padding: 0.6em 1em;
    box-sizing: border-box;
    border-radius: 2em;
  }
}
</style>
